export default __webpack_public_path__ + "static/CHI-ColorLogo-bdf0e671bf1f929ed3e4d487c3af2150.jpg";